import React from 'react';
import PropTypes from 'prop-types';

import Button from '../global/Button';
import IdentityAvatarContainer from '../../containers/global/identity/IdentityAvatarContainer';
import TrashIcon from '../icons/TrashIcon';

const propTypes = {
  albumFolderId: PropTypes.string,
  rosterIdentities: PropTypes.arrayOf(PropTypes.object),
  onRemove: PropTypes.func,
  disabled: PropTypes.bool,
};

// Lists the roster identities the user has picked so far during a
// face-recognition-disabled join, each with a remove control.
const DiscoverAlbumFolderNoFrJoinSelectedList = ({
  albumFolderId,
  rosterIdentities = [],
  onRemove,
  disabled = false,
}) => (
  <div className="no-fr-join-confirm-identity-container">
    {rosterIdentities.map(rosterIdentity => {
      const albumFolderLink = (rosterIdentity?.links?.records ?? []).find(
        r => r.album_folder?.id === albumFolderId,
      );

      return (
        <div key={rosterIdentity.id} className="item">
          <div className="w-100 d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <IdentityAvatarContainer
                className="mr-2"
                identity={{
                  ...rosterIdentity,
                  current_photo: rosterIdentity?.selfie_photo,
                }}
              />
              <div className="d-flex flex-column">
                <span className="text-dark text-extra-bold">
                  {rosterIdentity.first_name} {rosterIdentity.last_name}
                </span>
                {albumFolderLink?.ref_id && (
                  <span className="text-xs text-muted">
                    ID ending in {albumFolderLink.ref_id.slice(-3)}
                  </span>
                )}
              </div>
            </div>
            <Button
              btnStyle="reset"
              type="button"
              className="ml-auto d-flex"
              aria-label={`Remove ${rosterIdentity.first_name}`}
              disabled={disabled}
              onClick={() => onRemove(rosterIdentity)}
            >
              <TrashIcon size="15" color="#FE5851" />
            </Button>
          </div>
        </div>
      );
    })}
  </div>
);

DiscoverAlbumFolderNoFrJoinSelectedList.propTypes = propTypes;

export default DiscoverAlbumFolderNoFrJoinSelectedList;
